export class AbastecimentoBem {
    ativo: boolean;
    dataCriacao: string;
    dataUltimaAlteracao: string;
    data: string;
    quantidade: number;
    precoPorLitro: number;
    precoTotal: number;
    odometroHorimetro: number;
    tipoLancamento: number;
    notaFiscal: string;
    documento: string;
    empenho: string;
    ajuste : boolean;
    bemId: number;
    bombaId: number;
    combustivelId: number;
    areaId: number;
    motoristaId: number;
    localId: number;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/abastecimento-bens/shared/abastecimento-bem.model.ts
 **/